<template>
  <div>
    <h1 class="display-3">Zawieszenie i poświęcenie votum ryngrafów Armii Krajowej w Kościołach na Litwie</h1><br/>
    <b-row>
      <b-col cols="11">
        <p>
          W kwietniu 2011r. Prezes Okręgu Wileńskiego Światowego Związku Żołnierzy Armii Krajowej – Janusz Bohdanowicz –
          wziął udział w uroczystości poświęcenia nowej dzwonnicy przy kaplicy w Skorbucianach koło Wilna, gdzie znajduje
          się cmentarz żołnierzy 7 Wileńskiej Brygady AK, poległych w czasie II Wojny Światowej. W trakcie tego spotkania ze
          strony Prezesa Akcji Wyborczej Polaków na Litwie, p. Waldemara Tomaszewskiego, poszła propozycja upamiętnienia miejsc
          pochówku żołnierzy AK z tej i innych brygad wileńskich przez zainstalowanie we właściwych kościołach odpowiednich
          ryngrafów – votum.
        </p>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="6">
        <p>
          Sprawa ta została omówiona na następnym spotkaniu w lipcu 2011r. w Krawczunach, z
          okazji uroczystości rocznicy Operacji „Ostra Brama”, czyli walk AK o Wilno. Ustalono, że także ryngrafy –
          vota zostaną umieszczone w kościołach, przy których znajduje się cmentarz poległych żołnierzy:
          <ul class="mt-4">
            <li>3 Brygady – w Koloni Wileńskiej</li>
            <li>6 Brygady – w Koleśnikach</li>
            <li>7 Brygady – w Skorbucianach</li>
          </ul>
        </p>
      </b-col>
      <b-col lg="4">
        <b-img center fluid src="/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_1.jpg"/><br/>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="6">
        <p>
          Patronat nad tą akcją objęła Akcja Wyborcza Polaków na Litwie, biorąc na siebie dokonanie niezbędnych uzgodnień
          z parafiami w/w kościołów, lokalnymi władzami (rejonowymi i gminnymi) oraz właściwymi szkołami.
        </p>
        <p>
          Powyższe ryngrafy zostały zaprojektowane przez właściwe brygady według jednego ogólnego wzoru, w porozumieniu z
          Zarządem Okręgu Wileńskiego SZŻAK. Brygady sfinansowały też wykonanie tych ryngrafów.
        </p>
        <p>
          Uroczyste poświęcenie zainstalowanych już w kościołach ryngrafów nastąpiło w dniu 13-15 maja 2012 r. w
          obecności delegacji z Polski, obejmującej przedstawicieli Zarządu Okręgu Wileńskiego SZŻAK i środowisk
          zainteresowanych brygad. W uroczystościach tych wzięli też udział przedstawiciele Konsulatu RP na Litwie,
          Akcji Wyborczej Polaków na Litwie i lokalnych władz.
        </p>
      </b-col>
      <b-col lg="5">
        <b-img center fluid src="/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_2.jpg"/><br/>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="11">
        <p>
          Osobom z miejscowej ludności polskiej na Litwie, które przyczyniły się do zainstalowania omawianych ryngrafów –
          votum i do zorganizowania uroczystości ich poświęcenia zostały w dowód wdzięczności wręczone pamiątkowe ryngrafy
          poszczególnych brygad – w sumie 21 ryngrafów.
        </p>
        <p>
          Najważniejsze momenty uroczystości przedstawia film, którego nagranie zostało sfinansowane z
          funduszy przekazanych przez Środowisko Wileńskie AK w USA.
        </p>
      </b-col>
    </b-row>

    <b-row align-h="center">
      <b-col cols="12" md="9" >
        <b-carousel class="carousel_votum"
          style="text-shadow: 1px 1px 2px #333; margin: 0 0em 2em 0em;"
          controls
          indicators
          background="#ababab"
          :interval="0"
        >
          <div v-for="carousel in carousels" :key="carousel.id">
            <b-carousel-slide
              :caption="carousel.title"
              :text="carousel.text"
              :img-src="carousel.img"
            ></b-carousel-slide>
          </div>
        </b-carousel>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import votum from '@/models/aktualnosci/zawiesz_posw_votum.js'

export default {
  name: 'zawiesz_posw_votum',
  data: function(){
    return{
      carousels: votum.carousel
    }
  },
  metaInfo:{
    title: 'Zawieszenie i poświęcenie votum ryngrafów Armii Krajowej w Kościołach na Litwie',
    meta:[
      {name: 'description', content: 'W kwietniu 2011r. Prezes Okręgu Wileńskiego Światowego Związku Żołnierzy Armii Krajowej – Janusz Bohdanowicz – wziął udział w uroczystości poświęcenia nowej dzwonnicy przy kaplicy w Skorbucianach koło Wilna, gdzie znajduje się cmentarz żołnierzy 7 Wileńskiej Brygady AK, poległych w czasie II Wojny Światowej.' },
      {name: 'og:url', content: 'http://akwilno.pl/zawiesz_posw_votum' },
      {name: 'og:title', content: 'Zawieszenie i poświęcenie votum ryngrafów Armii Krajowej w Kościołach na Litwie' },
      {name: 'og:image', content: '/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_1.jpg' },
      {name: 'og:description', content: 'W kwietniu 2011r. Prezes Okręgu Wileńskiego Światowego Związku Żołnierzy Armii Krajowej – Janusz Bohdanowicz – wziął udział w uroczystości poświęcenia nowej dzwonnicy przy kaplicy w Skorbucianach koło Wilna, gdzie znajduje się cmentarz żołnierzy 7 Wileńskiej Brygady AK, poległych w czasie II Wojny Światowej.' },
      {name: 'twitter:url', content: 'http://akwilno.pl/zawiesz_posw_votum' },
      {name: 'twitter:title', content: 'Zawieszenie i poświęcenie votum ryngrafów Armii Krajowej w Kościołach na Litwie' },
      {name: 'witter:image', content: '/aktualnosci/zawiesz_posw_votum/zawiesz_posw_votum_foto_1.jpg' },
      {name: 'twitter:description', content: 'W kwietniu 2011r. Prezes Okręgu Wileńskiego Światowego Związku Żołnierzy Armii Krajowej – Janusz Bohdanowicz – wziął udział w uroczystości poświęcenia nowej dzwonnicy przy kaplicy w Skorbucianach koło Wilna, gdzie znajduje się cmentarz żołnierzy 7 Wileńskiej Brygady AK, poległych w czasie II Wojny Światowej.' }
    ]
  }
}
</script>

<style>
  .carousel_votum .carousel-caption,
  .carousel_votum .carousel-control-prev-icon,
  .carousel_votum .carousel-control-next-icon{
    background-color: rgba(0, 0, 0, 0.4)
  }
</style>



// WEBPACK FOOTER //
// src/components/aktualnosci/zawiesz_posw_votum.vue